exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidenav{padding:0;background:#efefef;border-right:1px solid #000}.box{border-top:1px solid #000}.sidenav a{padding:8px 8px 8px 20px;text-decoration:none;font-size:20px;display:block;background-color:#fff;color:#000;border-bottom:1px solid #000;-webkit-transition-duration:.4s;transition-duration:.4s}.sidenav a:hover{background:#d3d3d3}.highlight{background:#2d3f50!important;color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-676492a6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/sideNav.vue
// module id = 74
// module chunks = 0